'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreEmail(email) {
  this.a00 = null;
  this.a00 = email;
}
export { $c_Lpresto_types$proto$StoreEmail as $c_Lpresto_types$proto$StoreEmail };
$p = $c_Lpresto_types$proto$StoreEmail.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreEmail;
/** @constructor */
function $h_Lpresto_types$proto$StoreEmail() {
}
export { $h_Lpresto_types$proto$StoreEmail as $h_Lpresto_types$proto$StoreEmail };
$h_Lpresto_types$proto$StoreEmail.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$StoreEmail) && (this.a00 === x$0.a00)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "StoreEmail";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.a00;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$StoreEmail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lU)));
}
export { $isArrayOf_Lpresto_types$proto$StoreEmail as $isArrayOf_Lpresto_types$proto$StoreEmail };
var $d_Lpresto_types$proto$StoreEmail = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreEmail, "presto.types$proto$StoreEmail", ({
  lU: 1,
  m6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$StoreEmail as $d_Lpresto_types$proto$StoreEmail };
//# sourceMappingURL=presto.types$proto$-Store-Email.js.map
